/**
 * K2 (lesson-redo DESIGN.md): one history entry per lesson opened in the
 * window. Opening a lesson from the feed pushes ?lesson=<short>; a related
 * lesson pushes another. ‹ Back = history.back() (the previous lesson loads in
 * place); × closes to the feed in one step (history.go(-depth)); the phone's
 * back gesture is a popstate: the previous lesson, else the sheet closes.
 *
 * ?lesson= is the sheet's alone: a change of it never re-enters the reader
 * (ReaderPage's route watcher skips it and asks navStep what to do).
 */

const parse = (path) => {
  try { return new URL(String(path || ''), 'http://x') } catch (e) { return null }
}

/** The path and query, minus ?lesson=, as one comparable string. */
function keyOf(path) {
  const u = parse(path)
  if (!u) return String(path || '')
  u.searchParams.delete('lesson')
  const q = [...u.searchParams.entries()].sort(([a], [b]) => a.localeCompare(b))
  return `${u.pathname}?${q.map(([k, v]) => `${k}=${v}`).join('&')}`
}

/** True when only ?lesson= differs between two addresses. */
export function onlyLessonChanged(to, from) {
  if (from === undefined || from === null) return false
  return keyOf(to) === keyOf(from)
}

export const lessonQuery = (query, short) => ({ ...(query || {}), lesson: short })
export function withoutLesson(query) {
  const q = { ...(query || {}) }
  delete q.lesson
  return q
}

/**
 * What the address asks of the sheet. `want`: the route's ?lesson= ('' for
 * none); `showing`: the lesson in the sheet ('' when closed); `depth`: how
 * many entries the sheet has pushed; `stack`: their shorts, oldest first.
 */
export function navStep({ want = '', showing = '', depth = 0, stack = [] } = {}) {
  if (!want) return showing ? { do: 'close' } : { do: 'none' }
  if (!showing) return { do: 'open', short: want }
  if (want === showing) return { do: 'none' }
  const at = (stack || []).lastIndexOf(want)
  if (at >= 0 && at < depth - 1) return { do: 'load', short: want, depth: at + 1, via: 'back' }
  return { do: 'load', short: want, depth: depth + 1, via: 'link' }
}
